import { render, staticRenderFns } from "./servicecard.vue?vue&type=template&id=2f24c027&lang=true&"
import script from "./servicecard.vue?vue&type=script&lang=js&"
export * from "./servicecard.vue?vue&type=script&lang=js&"
import style0 from "./servicecard.vue?vue&type=style&index=0&id=2f24c027&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports